import axios from 'axios';
import { Toast } from 'vant';
import { encrypt, decrypt } from './aes';

const service = axios.create({
  baseURL: 'https://tims.hamachi.site/api',
  timeout: 30000,
});

const NO_ENCRYPT_URLS = [
  '/appConfig/list',
  '/mx/ip-location',
];

function needEncrypt(url) {
  return !NO_ENCRYPT_URLS.some(item => url.includes(item));
}

service.interceptors.request.use(
  config => {
    if (config.method === 'post' && config.data) {
      try {
        if (!config._rawData && !config.data.encryptedData) {
          config._rawData = { ...config.data };
        }

        let dataToEncrypt = { ...(config._rawData || config.data) };
        delete dataToEncrypt.encryptedData;

        if (needEncrypt(config.url)) {
          config.data = {
            encryptedData: encrypt(dataToEncrypt),
          };
        } else {
          config.data = dataToEncrypt;
        }
      } catch (error) {
        console.error('[请求加密失败]:', error);
        Toast.fail('请求加密失败');
        return Promise.reject(error);
      }
    }
    return config;
  },
  error => Promise.reject(error)
);

service.interceptors.response.use(
  async response => {
    let res = response.data;

    try {
      if (res && res.encrypted && res.data) {
        if (typeof res.data === 'string') {
          res.data = decrypt(res.data, true);
        }
        if (res.data && (res.data.status || res.data.success || res.data.code !== undefined || res.data.shops || res.data.goods || res.data.orderId)) {
          // keep envelope; callers use response.data / response.success
        }
      } else if (res && typeof res === 'object' && res.encryptedData) {
        res = decrypt(res.encryptedData, true);
      }
    } catch (error) {
      console.error('[响应解密失败]:', error);
    }

    if (res.success || res.message === 'ok' || res.status) {
      return res;
    }

    const error = new Error(res.message || 'Error');
    error.response = res;
    error.config = response.config;
    return Promise.reject(error);
  },
  async error => {
    if (error.response && error.response.data) {
      const res = error.response.data;
      const customError = new Error(res.message || error.message || 'Error');
      customError.response = res;
      customError.status = error.response.status;
      customError.config = error.config;
      return Promise.reject(customError);
    }
    return Promise.reject(error);
  }
);

export default service;
